import _ from 'lodash';
import sum from 'legacy-src/utility/Sum';

function combined({ content }, state, feedback, children = {}) {
  const statuses = {};
  _.forEach(children, (child) => {
    if (child && !('complete' in child)) {
      child.complete = child.viewed || 0;
    }
    _.forEach(child, (value, key) => {
      if (!statuses[key]) {
        statuses[key] = [value];
      } else {
        statuses[key].push(value);
      }
    });
  });

  const childCount = content.items.length;
  const reportingCount = _(children)
    .pickBy((v) => v)
    .size();
  return _.mapValues(statuses, (values) => {
    // We shouldn't consider any status "100%" until all child
    // items have been viewed and are reporting a status.
    if (reportingCount === childCount) {
      return sum(values) / values.length;
    }
    return sum(values) / childCount;
  });
}

function viewed(content, state = {}) {
  return {
    viewed: state.viewed ? 1 : 0,
  };
}

function submittable({ content }, state = {}, feedback = {}) {
  const { selection, attempts = [], submitted } = state;
  const selected = selection !== undefined && selection !== null;
  const reviewing =
    submitted &&
    (feedback.complete ||
      (content && attempts.length === (content.retries || 0)));

  const status = {
    viewed: state.viewed ? 1 : 0,
    selected: selected ? 1 : 0,
    complete: reviewing ? 1 : selected ? 0.5 : 0,
  };

  if (!reviewing) {
    status.submittable = selected || (content && content.optional) ? 1 : 0;
  }
  return status;
}

function lockable(item, state, feedback, children) {
  const result = combined(item, state, feedback, children);
  if (item.content.requireCompletion) {
    result.children = {};
    let locked;
    _(children)
      .keys()
      .sortBy()
      .forEach((path, index, paths) => {
        if (!locked) {
          if (index === 0) {
            locked = false;
          } else {
            locked = children[paths[index - 1]].complete !== 1;
          }
        }
        result.children[path] = { locked };
      });
  }
  return result;
}

export { combined, viewed, submittable, lockable };
